import { DatePipe } from '@angular/common';
import { Component, inject, input, resource } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { formatCNPJ } from '@brazilian-utils/brazilian-utils';
import { SmartOrpcClientService } from '../../../shared/services/smart-orpc-client.service';
import { SnackbarService } from '../../../shared/services/snackbar.service';
import { ContractListComponent } from '../../adm/contract-list/contract-list.component';

@Component({
  selector: 'app-organization-details',
  imports: [
    DatePipe,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    ReactiveFormsModule,
    RouterModule,
    ContractListComponent,
  ],
  templateUrl: './organization-details.component.html',
  styleUrl: './organization-details.component.scss',
})
export class OrganizationDetailsComponent {
  orpc = inject(SmartOrpcClientService);
  router = inject(Router);
  snackBar = inject(SnackbarService);

  formatCNPJ = formatCNPJ;

  readonly id = input.required<string>();

  readonly organization = resource({
    params: () => ({ id: this.id() }),
    loader: async ({ params }) => {
      const { error, data } = await this.orpc.safeClient.organization.byId(
        Number(params.id),
      );
      if (error) {
        return;
      }
      return data;
    },
  });

  navigateToEditOrganization(id: number) {
    this.router.navigate(['admin', 'organizations', 'edit', id]);
  }
}
